import { DefaultPageSizeOptions } from "../../Pagination/Pagination.constants";
import type { PaginationProps } from "../../Pagination/types";
import type { ItemBaseType } from "../types";

export const getNextAvailableRowIdx = <ItemType extends ItemBaseType>(
  dir: "forward" | "reverse",
  currIdx: number,
  allRows: ItemType[],
  selected?: Record<string, ItemType>,
  opts?: {
    floor: number;
    ceiling: number;
  }
) => {
  let modifier = 0;
  let accessIdx = dir === "forward" ? currIdx + modifier : currIdx - modifier;
  const ceil = opts?.ceiling ?? allRows.length;
  const floor = opts?.floor ?? 0;

  while (
    ((dir === "forward" && accessIdx < ceil) ||
      (dir === "reverse" && accessIdx > floor)) &&
    allRows[accessIdx]?.id &&
    selected?.[allRows[accessIdx].id]
  ) {
    modifier++;
    accessIdx = dir === "forward" ? currIdx + modifier : currIdx - modifier;
  }

  return accessIdx;
};

export const getRowNumber = (
  dir: "forward" | "reverse",
  currIdx: number,
  pagination?: Pick<
    PaginationProps,
    "page" | "pageSize" | "total" | "pageTotal"
  >
): number => {
  const pageSize = pagination?.pageSize ?? DefaultPageSizeOptions[0];

  if (pagination?.total !== undefined) {
    return dir === "forward"
      ? (pagination.page - 1) * pageSize + (currIdx + 1)
      : pagination.total - (pagination.page - 1) * pageSize - currIdx;
  }

  return dir === "forward"
    ? currIdx + 1
    : Math.min(pageSize, pagination?.pageTotal ?? pageSize) - currIdx;
};
